import { useForm, type SubmitHandler } from "react-hook-form"

import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import RHFTextfield from "@/components/form-fields/rhf-textfield"
import type { User, UserEmailFormInput } from "@/types"
import { useUpdateUserEmail } from "@/hooks/api/use-users"

const UserEmailForm = ({
    user,
    closeCallback,
} : {
    user: User,
    closeCallback?: () => void,
}) => {

    const initialValues = {
        email: user.email ?? '',
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
        watch,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
        error,
        setError,
    } = useFormStates(() => reset(initialValues))

    const mutationCreate = useUpdateUserEmail(
        user.id,
        {
            setRequestInProgress,
            onSuccessCallback: closeCallback,
            onErrorCallback(errorMessage) {
                setError(errorMessage)
            }
        }
    )

    const onSubmit: SubmitHandler<UserEmailFormInput> = data => {
        setRequestInProgress(true)
        mutationCreate.mutate(data)
    }

    const filledEmail = watch('email')

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            heading={'Upravit email'}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={false}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            error={error}
            setError={setError}
            disableSave={user.email === filledEmail}
        >
            <RHFTextfield
                name="email"
                control={control}
                label="Email"
                required
                type="email"
            />
        </Form>
    )
}

export default UserEmailForm
